import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { PayslipListEmployee } from '../components/Payslips';
import { Menu, FileText, Bot } from 'lucide-react';

const PayslipsPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const sidebarProps = {
    chats: [], activeChatId: null,
    onNewChat: () => navigate('/'),
    onSelectChat: (id) => navigate(`/chat/${id}`),
    onDeleteChat: () => {},
    isOpen: sidebarOpen,
    onClose: () => setSidebarOpen(false)
  };

  return (
    <div className="h-screen w-screen flex bg-white overflow-hidden">
      {sidebarOpen && <div className="fixed inset-0 bg-slate-900/40 z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />}
      <Sidebar {...sidebarProps} />

      <main className="flex-1 flex flex-col min-w-0 bg-slate-50/30">
        <header className="h-14 border-b border-slate-200 bg-white flex items-center justify-between px-4 lg:px-6 sticky top-0 z-20">
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="icon" className="lg:hidden -ml-2" onClick={() => setSidebarOpen(true)}>
              <Menu className="w-5 h-5" />
            </Button>
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-blue-700 flex items-center justify-center">
                <FileText className="w-4 h-4 text-white" />
              </div>
              <div>
                <div className="text-sm font-semibold text-slate-900">Le mie buste paga</div>
                <div className="text-xs text-slate-500">Visualizza e scarica le tue buste paga</div>
              </div>
            </div>
          </div>
          <Button variant="ghost" onClick={() => navigate('/')} className="gap-2 text-sm">
            <Bot className="w-4 h-4" /> Chat
          </Button>
        </header>

        <div className="flex-1 overflow-y-auto custom-scroll">
          <div className="max-w-5xl mx-auto px-4 lg:px-6 py-6">
            <PayslipListEmployee />
          </div>
        </div>
      </main>
    </div>
  );
};

export default PayslipsPage;
